import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Timeline } from "react-twitter-widgets";
import Spinner from "react-bootstrap/Spinner";
import logoImage from "../../../assets/images/logo-img.png"
import { fetchLinks } from '../../../store/reducers/getTwitterLinkSlice';
import Head from '../Head';
import CommunityPageMain from "./CommunityPageMain";
import Footer from '../Footer';
import Jucier from '../../../components/jucier';
const Community = () => {
  const dispatch = useDispatch();
  const { links, loading, error } = useSelector((state) => state?.fetchTwitterLink);
  const [isOpen, setIsOpen] = useState(false);
  const [userNames, setUserName] = useState([]);
  const [loadingStates, setLoadingStates] = useState([]);

  useEffect(() => {
    dispatch(fetchLinks());
  }, [dispatch]);

  useEffect(() => {
    if (links?.data) {
      setUserName(links?.data);
      setLoadingStates(Array(links?.data?.length).fill(true)); // Initialize loading states based on userNames length
    }
  }, [links]);

  const handleLoad = (index) => {
    setLoadingStates((prevStates) => {
      const newStates = [...prevStates];
      newStates[index] = false;
      return newStates;
    });
  };

  return (
    <>
     <div className="top-head-section-new"></div>
    <div className="main-body-sec">
      <Head />
        <section id="content-wrapper">
          <CommunityPageMain />
          <div className="top-story-section mt-5">
            <h2>Community Social Posts</h2>
            <br/><br/>
          <div className="container mb-3 community-twitter-section">
            <div className="community-outer-section">
              <div className="row">
              <Jucier />
              </div>
            </div>
          </div>
          </div>
        </section>
      </div>

    <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 community-disclosur">
          <div className="lend-cont-inner-in container">
            <p>
              <strong>Disclosure: </strong>
              LF Coin ($LAL) is a community-driven meme coin created to
              celebrate sports fandom and foster community engagement.
              LF Coin is not affiliated with the Los Angeles Lakers, the
              National Basketball Association (NBA), or any associated
              organizations. The project operates independently and is
              solely focused on building a decentralized community of
              sports enthusiasts. As a meme coin, LF Coin carries no
              intrinsic value and should not be considered an investment
              or security.
            </p>
          </div>
        </div>
      </div>
      <div className="about-footer">
      <Footer/>
      </div>
    </>
  );
};

export default Community;
